import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BackButton from "../components/BackButton";
import { API_URL } from "../config";

function PlayingHistory() {
  const navigate = useNavigate();

  // ✅ 1. FAST LOAD LOGIC: LocalStorage se data uthao
  const savedData = localStorage.getItem("playingHistory");
  const parsedData = savedData ? JSON.parse(savedData) : null;

  // Initialize State (Agar local data hai to wahi use karo)
  const [historyData, setHistoryData] = useState(parsedData?.history || []);
  const [stats, setStats] = useState(parsedData?.stats || { invested: 0, winnings: 0, profit: 0 });
  
  // ✅ 2. LOADING LOGIC: Loading tabhi dikhana jab LocalStorage khali ho
  const [loading, setLoading] = useState(!parsedData);
  
  // 📅 Filter State
  const [filterDate, setFilterDate] = useState("");

  // --- 1. FETCH DATA (Background) ---
  const fetchHistory = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
        navigate("/auth");
        return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/user/playing-history`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        processHistoryData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line
  }, []);

  // --- 2. DATA PROCESSING ---
  const processHistoryData = (matches) => {
    const grouped = {};
    let totalInv = 0;
    let totalWin = 0;

    matches.forEach((match) => {
      const dateObj = new Date(match.createdAt);
      const dateKey = dateObj.toLocaleDateString("en-GB", {
        day: "numeric", month: "short", year: "numeric"
      });
      const rawDateKey = dateObj.toISOString().split('T')[0];

      totalInv += match.entryFee || 0;
      totalWin += match.winningAmount || 0;

      if (!grouped[dateKey]) {
        grouped[dateKey] = {
          id: dateKey,
          fullDate: dateKey,
          rawDate: rawDateKey,
          date: getRelativeDate(dateObj),
          contests: 0,
          invested: 0,
          winnings: 0,
          profit: 0
        };
      }

      grouped[dateKey].contests += 1;
      grouped[dateKey].invested += match.entryFee || 0;
      grouped[dateKey].winnings += match.winningAmount || 0;
      grouped[dateKey].profit += (match.winningAmount || 0) - (match.entryFee || 0);
    });

    const sortedHistory = Object.values(grouped).sort((a, b) => 
        new Date(b.rawDate) - new Date(a.rawDate)
    );

    const newStats = {
      invested: totalInv,
      winnings: totalWin,
      profit: totalWin - totalInv
    };

    // ✅ 3. Update State & LocalStorage
    setHistoryData(sortedHistory);
    setStats(newStats);
    localStorage.setItem("playingHistory", JSON.stringify({ history: sortedHistory, stats: newStats }));
  };

  const getRelativeDate = (date) => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return "Today";
    if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
    return date.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  };

  // --- 3. FILTER LOGIC ---
  const displayedHistory = filterDate 
    ? historyData.filter(item => item.rawDate === filterDate) 
    : historyData;

  // ✅ 4. SHIMMER LOADER (Sirf first time user ke liye)
  if (loading) return (
    <div style={{ minHeight: "100vh", background: "#f8f9fc" }}>
        {/* Header Shimmer */}
        <div className="pb-5 pt-2 px-3 position-relative placeholder-glow" style={{ background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)", borderBottomLeftRadius: "30px", borderBottomRightRadius: "30px", height: "200px" }}>
            <div className="mt-4 mb-4">
                <span className="placeholder col-6 bg-secondary opacity-50 rounded mb-2"></span>
                <span className="placeholder col-4 bg-secondary opacity-50 rounded d-block"></span>
            </div>
            {/* Stats Card Shimmer */}
            <div className="card border-0 shadow-lg" style={{ borderRadius: "16px", background: "rgba(255,255,255,0.1)" }}>
                <div className="card-body">
                    <div className="row text-center">
                        <div className="col-4 border-end border-secondary"><span className="placeholder col-8 bg-secondary opacity-50 rounded"></span></div>
                        <div className="col-4 border-end border-secondary"><span className="placeholder col-8 bg-secondary opacity-50 rounded"></span></div>
                        <div className="col-4"><span className="placeholder col-8 bg-secondary opacity-50 rounded"></span></div>
                    </div>
                </div>
            </div>
        </div>
        {/* List Shimmer */}
        <div className="container-fluid px-3 mt-5 pt-4 placeholder-glow">
            {[1, 2, 3].map(i => (
                <div key={i} className="card border-0 shadow-sm mb-3" style={{ borderRadius: "16px", height: "140px" }}>
                    <div className="card-body p-3">
                        <div className="d-flex justify-content-between mb-3">
                            <span className="placeholder col-4 bg-secondary opacity-25 rounded"></span>
                            <span className="placeholder col-3 bg-secondary opacity-25 rounded-pill"></span>
                        </div>
                        <div className="row g-2 mb-3">
                            <div className="col-4"><span className="placeholder col-12 bg-secondary opacity-10 rounded" style={{height: '40px'}}></span></div>
                            <div className="col-4"><span className="placeholder col-12 bg-secondary opacity-10 rounded" style={{height: '40px'}}></span></div>
                            <div className="col-4"><span className="placeholder col-12 bg-secondary opacity-10 rounded" style={{height: '40px'}}></span></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f8f9fc", paddingBottom: "100px" }}>
      
      {/* HEADER */}
      <div 
        className="pb-5 pt-2"
        style={{ 
            background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)", 
            borderBottomLeftRadius: "30px", 
            borderBottomRightRadius: "30px"
        }}
      >
        <div className="container-fluid px-3">
          <BackButton to="/home" label="" className="text-white" />
          
          <div className="d-flex justify-content-between align-items-end mt-2 mb-4">
            <div>
                <h3 className="fw-bold text-white mb-0">Playing History</h3>
                <p className="text-white-50 small mb-0">Track your performance</p>
            </div>
            
            {/* 📅 DATE PICKER BUTTON */}
            <div className="position-relative">
                {filterDate ? (
                    <button 
                        className="btn btn-danger btn-sm rounded-pill px-3 d-flex align-items-center"
                        onClick={() => setFilterDate("")}
                    >
                        <i className="bi bi-x-circle-fill me-2"></i> {filterDate}
                    </button>
                ) : (
                    <div className="btn btn-dark btn-sm rounded-pill border border-secondary px-3 position-relative overflow-hidden">
                        <i className="bi bi-calendar3 me-2"></i> Select Date
                        <input 
                            type="date" 
                            className="position-absolute top-0 start-0 w-100 h-100" 
                            style={{ opacity: 0, cursor: 'pointer' }}
                            onChange={(e) => setFilterDate(e.target.value)}
                        />
                    </div>
                )}
            </div>
          </div>

          {/* STATS CARD */}
          <div className="card border-0 shadow-lg" style={{ borderRadius: "16px", background: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)" }}>
            <div className="card-body text-white">
                <div className="row text-center">
                    <div className="col-4 border-end border-secondary">
                        <small className="opacity-75" style={{fontSize: "10px"}}>INVESTED</small>
                        <h5 className="fw-bold mb-0">₹{stats.invested}</h5>
                    </div>
                    <div className="col-4 border-end border-secondary">
                        <small className="opacity-75" style={{fontSize: "10px"}}>WINNINGS</small>
                        <h5 className="fw-bold mb-0 text-success">₹{stats.winnings}</h5>
                    </div>
                    <div className="col-4">
                        <small className="opacity-75" style={{fontSize: "10px"}}>NET P/L</small>
                        <h5 className={`fw-bold mb-0 ${stats.profit >= 0 ? "text-success" : "text-danger"}`}>
                            {stats.profit >= 0 ? "+" : ""}₹{stats.profit}
                        </h5>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* HISTORY LIST */}
      <div className="container-fluid px-3 px-md-4" style={{ marginTop: "-20px" }}>
        
        {displayedHistory.length > 0 ? (
          <div className="d-flex flex-column gap-3">
            {displayedHistory.map((entry) => {
              const isProfit = entry.profit >= 0;
              const profitColor = isProfit ? "success" : "danger";
              const profitBg = isProfit ? "#ecfdf5" : "#fef2f2"; 
              const profitBorder = isProfit ? "#10b981" : "#ef4444";

              const total = entry.invested + entry.winnings;
              const winPercent = total > 0 ? (entry.winnings / total) * 100 : 0;

              return (
                <div 
                    key={entry.id} 
                    className="card border-0 shadow-sm" 
                    style={{ borderRadius: "16px", borderLeft: `5px solid ${profitBorder}` }}
                >
                  <div className="card-body p-3">
                    
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <h6 className="fw-bold text-dark mb-0">{entry.date}</h6>
                            <small className="text-muted" style={{fontSize: "11px"}}>{entry.fullDate}</small>
                        </div>
                        <span className={`badge bg-${profitColor}-subtle text-${profitColor} px-3 rounded-pill`}>
                            {isProfit ? "PROFIT" : "LOSS"}
                        </span>
                    </div>

                    <div className="row g-2 mb-3">
                        <div className="col-4">
                            <div className="p-2 rounded bg-light text-center">
                                <small className="text-muted fw-bold d-block" style={{fontSize: "9px"}}>CONTESTS</small>
                                <span className="fw-bold text-dark">{entry.contests}</span>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="p-2 rounded bg-light text-center">
                                <small className="text-muted fw-bold d-block" style={{fontSize: "9px"}}>INVESTED</small>
                                <span className="fw-bold text-dark">₹{entry.invested}</span>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="p-2 rounded text-center" style={{ background: profitBg }}>
                                <small className={`fw-bold d-block text-${profitColor}`} style={{fontSize: "9px"}}>WINNINGS</small>
                                <span className={`fw-bold text-${profitColor}`}>₹{entry.winnings}</span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between">
                        <div className="flex-grow-1 me-3">
                            <div className="progress" style={{ height: "6px", borderRadius: "10px" }}>
                                <div 
                                    className={`progress-bar bg-${profitColor}`} 
                                    role="progressbar" 
                                    style={{ width: `${winPercent}%` }}
                                ></div>
                            </div>
                            <small className="text-muted" style={{fontSize: "10px"}}>Win Ratio</small>
                        </div>
                        <div className="text-end">
                            <small className="text-muted d-block" style={{fontSize: "10px"}}>Net Profit</small>
                            <h6 className={`fw-bold mb-0 text-${profitColor}`}>
                                {isProfit ? "+" : ""}₹{entry.profit}
                            </h6>
                        </div>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          /* Empty State based on Filter */
          <div className="text-center py-5 mt-4">
             <div className="bg-white rounded-circle d-inline-flex p-4 shadow-sm mb-3">
                <i className="bi bi-calendar-x fs-1 text-secondary opacity-50"></i>
             </div>
             <h5 className="fw-bold text-dark">No history found</h5>
             <p className="text-muted small">
                {filterDate ? `No matches played on ${filterDate}` : "Join a contest to see your history here."}
             </p>
             {filterDate ? (
                 <button className="btn btn-outline-dark rounded-pill px-4 fw-bold mt-2" onClick={() => setFilterDate("")}>
                    Clear Filter
                 </button>
             ) : (
                 <button className="btn btn-primary rounded-pill px-4 fw-bold mt-2" onClick={() => navigate('/home')}>
                    Join a Contest
                 </button>
             )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlayingHistory;